<template lang="html">
  <div class="layout-private">

    <div class="header-private">
      <div class="container">
        <div class="row row-header">
          <div class="col-12 text-center">
            <router-link to="/" class="logo">
              <img src="../assets/img/logo-why-care@2x.png" alt="why/care" width="197px" height="59px"><br>
              <p v-if="location && location.name" class="location-subtitle">{{ location.name }}</p>
            </router-link>

            <button v-if="allowedRoute" class="btn btn-icon-only btn-nav-open" @click="showNav=true"><i class="far fa-fw fa-bars"></i></button>

          </div> <!-- /.col -->
        </div> <!-- /.row -->
      </div> <!-- /.container -->
    </div> <!-- /.header-private -->

    <div class="container">
      <slot></slot>
    </div> <!-- /.container -->

     <div v-if="showLogOutConfirmation" class="modal modal-app modal-log-out" tabindex="-1">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-body text-center">
            <button class="btn btn-icon btn-close" @click="showLogOutConfirmation=false"><i class="fas fa-times"></i></button>
            <h2> Are you sure you want to log out?</h2>
            <p>An MFA Log In code from the company phone number will be required to log in again.</p>
            <div class="btn-footer d-flex justify-content-center align-items-center">
              <button v-if="!loading" @click.prevent="showLogOutConfirmation=false" class="btn btn-green">Stay Logged In<i class="fas fa-angle-right fa-fw"></i></button>
              <button v-if="!loading" @click.prevent="logOut" class="btn btn-salmon">Log Out<i class="fas fa-angle-right fa-fw"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- /.modal-log-out -->
    <div v-if="showLogOutConfirmation" class="modal-backdrop"></div>

     <div v-if="showNav && allowedRoute" class="nav-main d-flex flex-column">
      <div class="nav-header">
        <img src="../assets/img/logo-why-care@2x.png" alt="why/care" width="197px" height="59px">
      </div>
      <div class="flex-grow-1">
        <ul class="nav nav-pills nav-pw flex-column w-100">
          <li>
            <router-link
              to="/"
              class="nav-link"
              @click.native="showNav=false;resetPatientData()"
            >
              Find Treatment Plan
            </router-link>
          </li>
          <li>
            <router-link
              to="/stats/snapshot"
              class="nav-link"
              @click.native="showNav=false;resetPatientData()"
            >
              Stats
            </router-link>
          </li>
          <li>
            <router-link
              to="/patient-outreach/unscheduled"
              class="nav-link"
              @click.native="showNav=false;resetPatientData()"
            >
              Patient Outreach
            </router-link>
          </li>
          <li>
            <router-link
              to="/appointments"
              class="nav-link"
              @click.native="showNav=false;resetPatientData()"
            >
              Today's Appointment List
            </router-link>
          </li>
          <li>
            <router-link
              to="/team"
              class="nav-link"
              @click.native="showNav=false;resetPatientData()"
            >
              Team
            </router-link>
          </li>
          <li class="text-center"><small><a href="#log-out" @click.prevent="showLogOutConfirmation=true;showNav=false">Log Out</a></small></li>
          <li v-if="user && !user.emailVerified" class="text-center">
            <button v-if="!emailSent" class="btn btn-sm btn-app" @click="verifyEmail">Verify Email Address <i class="fas fa-envelope"></i></button>
            <p v-if="emailSent" class="snug"><i class="color-green fas fa-check"></i> Email sent successfully</p>
          </li>
        </ul>
        <hr>
        <button class="btn btn-icon-only" @click="showNav=false"><i class="fal fa-fw fa-times"></i></button>
      </div>
      <div>
        <p class="snug sm light-color light-weight"><em>last major update: 10/19/26 6:00pm Central</em></p>
      </div>
      
    </div> <!-- /.nav-main -->

  </div> <!-- /.layout-private -->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  props: ['customer'],
  data () {
    return {
      showNav: false,
      emailSent: false,
      showLogOutConfirmation: false,
    }
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'location']),
    // only allow nav to appear on certain pages
    allowedRoute() {
      const allowedRouteNames = [
        'findPlans',
        'appointmentSelect',
        'statsSnapshot',
        'statsPathToHealth',
        'patientOutreachUnscheduled',
        'patientOutreachAll',
        'patientOutreachSnoozed',
        'patientOutreachCompleted',
        'team',
        'patientDetail',
      ];
      if(allowedRouteNames.includes(this.$route.name)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    resetPatientData() {
      store.dispatch('resetState');
      store.dispatch('clearPatNum');
      store.dispatch('clearPatName');
      store.dispatch('clearAppointment');
    },
    logOut () {
      this.$firebase.logOut()
    },
    verifyEmail() {
      if(this.user && !this.user.emailVerified) {
        console.log('sending email verification');
        this.$firebase.verifyEmail()
          .then(() => {
            this.emailSent = true;
          });
      }
    },
  },
  mounted () {

  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.header-private {
  padding: 75px 0 20px;
  margin-bottom: 0;
  position: relative;

  &:before,
  &:after {
    content: '';
    display: block;
    height: 5px;
    width: 50%;
    position: absolute;
    top: 0;
  }
  &:before {
    left: 0;
    background-color: @color-salmon;
    border-right: 1px solid @light-color;
  }
  &:after {
    left: 50%;
    background-color: @color-green;
  }
}
// make room for affix
.layout-private {
  overflow-x: hidden;
  overflow-y: hidden; // remove mysterious 2nd vertical scrollbar
}
// full page nav
.btn-nav-open {
  position: absolute;
  right: 0;
  top: 15px;
}
.nav-main {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: @color-green;
  z-index: 1000;
  text-align: center;
  // padding: 0 0 60px 0;
  padding: 0 0 10px 0;
  border-top: 20px solid @color-salmon;

  .nav-header {
    padding: 55px 0;
    background-color: @light-color;
    margin-bottom: 30px;
    height: fit-content;
  }
  .logo {
    margin-bottom: 20px;
  }
  hr {
    border-top-color: @light-color;
    margin: 20px 0;
  }
}
//  log out confirmation modal
.modal-log-out {
  .btn-footer .btn:last-child {
    margin-left: 15px;
  }
  .modal-body {
    padding: 50px;
  }
  h2 {
    margin: 0 0 20px;
  }
}
.modal-backdrop {
  background-color: @color-salmon;
  opacity: 0.95;
}
</style>
